module.exports = __webpack_public_path__ + "img/CustodyExpenseOperations.b44f48bc.svg";